import ParameterFieldBase, { IParameterFieldBaseOptions } from '../../../../_common/platform/ts/ParameterFieldBase';

import { TemplateList as EditComponent } from '../../tsx/TemplateList';

export class TemplateListField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];

    public static EditComponent = EditComponent;

    public getDefaultOptions() {
        return {
            noTitle: true
        };
    }

    constructor(glob, title: string, validators?: any, defaultVal: any = '', options?, directionOptions?) {
        super(glob, title, TemplateListField.defaultValidators, validators, defaultVal, options, directionOptions);
    }
}
